export const SUCCESS_FLASH_MESSAGE = 'SUCCESS_FLASH_MESSAGE';
export const ERROR_FLASH_MESSAGE = 'ERROR_FLASH_MESSAGE';
export const HIDE_FLASH_MESSAGE = 'HIDE_FLASH_MESSAGE';
